import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import CmtImage from "src/@coremat/CmtImage";
import { useSelector } from "react-redux";
import { ROLES } from "src/helpers/constants";

const ScheduleCall = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { tenant } = useSelector(({ auth }) => auth);
  const { role } = location.state || {};

  const getSchedulingLink = () => {
    switch (role) {
      case ROLES.FUNDER:
        return import.meta.env.VITE_FUNDER_SCHEDULING_LINK;
      case ROLES.VENDOR:
        return import.meta.env.VITE_VENDOR_SCHEDULING_LINK;
      default:
        return import.meta.env.VITE_DEFAULT_SCHEDULING_LINK;
    }
  };

  const handleBack = () => {
    navigate("/account-type");
  };

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh" width="100vw" className="bg-white">
      {/* Menu Bar */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        height={60}
        px={4}
        sx={{
          backgroundColor: "white",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
        }}
      >
        {/* Logo Container */}
        <Box flex={1} display="flex" justifyContent="center">
          <CmtImage
            alt="InvestorMatch Logo"
            height="40px"
            style={{ 
              display: "block",
              objectFit: "contain",
              maxHeight: "40px"
            }}
            src={(tenant?.logo || {})["2x"]?.path || "/images/logo-v1.png"}
          />
        </Box>
        
        {/* Back Button */}
        <Button
          type="button"
          variant="text"
          color="primary"
          onClick={handleBack}
          style={{ 
            fontWeight: 600, 
            fontSize: 16,
            position: "absolute",
            right: 24
          }}
        >
          Back
        </Button>
      </Box>

      {/* Embedded View */}
      <Box 
        width="100%" 
        height="calc(100vh - 60px)" 
        position="relative"
        mt={-10}
      >
        <iframe
          src={getSchedulingLink()}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            position: "absolute",
            top: 20,
            left: 0,
          }}
          title="Schedule Call"
        />
      </Box>
    </Box>
  );
};

export default ScheduleCall; 